import { Box, Typography, useTheme } from '@mui/material';
import { PAGE_HEIGHT } from '../constants';

type IProps = {
  height?: string;
};

export const ErrorScreen = ({ height = PAGE_HEIGHT }: IProps) => {
  const theme = useTheme();

  return (
    <Box height={height} sx={{ position: 'relative' }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 2,
          position: 'absolute',
          top: '1rem',
          bottom: '1rem',
          left: '1rem',
          right: '1rem',
          border: `1px solid ${theme.palette.error.light}`,
          borderRadius: '10px',
          backgroundColor: theme.palette.error.main + '08', // 8% opacity
        }}
      >
        <Typography variant='h4' textAlign='center'>
          Fehler!
        </Typography>
        <Typography variant='body1' textAlign='center'>
          Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.
        </Typography>
      </Box>
    </Box>
  );
};
